import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { RootState } from 'redux/store';
import { GadgetEditModel } from 'types/entity';

export const gadgetSchema = new schema.Entity(
  'gadget',
  {},
  { idAttribute: (value: GadgetEditModel) => value.gadget_id || '' },
);

export const gadgetsAdaptor = createEntityAdapter<GadgetEditModel>({
  selectId: (model) => model.gadget_id || '',
});

export const {
  selectById: selectGadgetById,
  selectIds: selectGadgetIds,
  selectEntities: selectGadgetEntities,
  selectAll: selectAllGadgets,
  selectTotal: selectTotalGadgets,
} = gadgetsAdaptor.getSelectors<RootState>((state) => state.gadgetUpdate);
